export const setStateCollapseMenuPest1 = (iscollapse = false) =>{
    return{
        type :'SET_STATE_COLLAPSE_MENU_PEST1',
        payload :iscollapse
    }
}

export const setStateCollapseMenuPest2 = (iscollapse = false) =>{
    return{
        type:'SET_STATE_COLLAPSE_MENU_PEST2',
        payload: iscollapse
    }
}